import { smsLogin, logout, getMemberInfo, pwdLogin } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    userInfo: {},
    token: getToken(),
    name: "",
    avatar: "",
    roles: [],
    permissions: [],
    userId: "",
    visible: false,
    navmenu: [],
    link: [],
    platform: "3",
    forgetPhone: "",
    roleType: -1, //0游客 2教师 3学生
    classId: -1, //左上角选择的班级id
    classLists: [], //阅读页左上角选择的班级
    toolBar: {}, // 隐私跳转用
    viewLocate: "", //文章跳转定位用的元素id
  },

  mutations: {
    SET_VIEWLOCATE: (state, viewLocate) => {
      state.viewLocate = viewLocate;
    },
    SET_CLASSLISTS: (state, classLists) => {
      state.classLists = classLists;
    },
    SET_ROLETYPE: (state, type) => {
      state.roleType = type;
    },
    SET_CLASSID: (state, classId) => {
      state.classId = classId;
    },
    SET_PLATFORM: (state, platform) => {
      state.platform = platform;
    },
    SET_TOOLBAR: (state, info) => {
      state.toolbar = info;
    },
    SET_FORGETPHONE: (state, phone) => {
      state.forgetPhone = phone;
    },
    SET_USERINFO: (state, info) => {
      state.userInfo = info;
    },
    SET_VISIBLE: (state, info) => {
      state.visible = info;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.userInfo.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId;
    },
    SET_NAV_MENU: (state, navmenu) => {
      state.navmenu = navmenu;
    },
    SET_LINK: (state, link) => {
      state.link = link;
    },
  },
  actions: {
    // 登录
    smsLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        smsLogin(userInfo)
          .then((res) => {
            setToken(res.token);
            // commit('SET_USERINFO', res.member)
            commit("SET_TOKEN", res.token);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    newLogin({ commit }, token) {
      setToken(token);
      setToken(token);
      commit("SET_TOKEN", token);
    },
    // 密码登录
    passwordLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        pwdLogin(userInfo)
          .then((res) => {
            setToken(res.token);
            // commit('SET_USERINFO', res.member)
            commit("SET_TOKEN", res.token);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /** 打开登录界面 */
    openLogin({ commit }, info) {
      console.log('1111',process.env)
      if (process.env.VUE_APP_SSO_LOGIN == '1') {
        window.location.href = `${process.env.VUE_APP_BASE_API}/oauth2/sso/authorize?returnUrl=${location.href}`;
      } else {
        commit("SET_VISIBLE", info);
      }
    },
    setAvatar({ commit }, info) {
      commit("SET_AVATAR", info);
    },
    setNavMemu({ commit }, info) {
      commit("SET_NAV_MENU", info);
    },
    setLink({ commit }, info) {
      commit("SET_LINK", info);
    },
    setPlatform({ commit }, info) {
      commit("SET_PLATFORM", info);
    },
    setToolbar({ commit }, info) {
      commit("SET_TOOLBAR", info);
    },
    setViewLocate({ commit }, info) {
      commit("SET_VIEWLOCATE", info);
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getMemberInfo()
          .then((res) => {
            const user = res.member;
            // const avatar = user.avatar === '' ? require('@/assets/images/profile.jpg') : process.env.VUE_APP_BASE_API + user.avatar
            commit("SET_USERINFO", user);
            // if (res.roles && res.roles.length > 0) {
            //   // 验证返回的roles是否是一个非空数组
            //   commit('SET_ROLES', res.roles)
            //   commit('SET_PERMISSIONS', res.permissions)
            // } else {
            commit("SET_ROLES", ["ROLE_DEFAULT"]);
            // }
            commit("SET_NAME", user.userName);
            commit("SET_USER_ID", user.id);
            // commit('SET_AVATAR', avatar)
            resolve(res);
          })
          .catch((error) => {
            removeToken();
            reject(error);
          });
      });
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (process.env.VUE_APP_SSO_LOGIN == '1') {
          commit("SET_TOKEN", "");
          commit("SET_ROLES", []);
          commit("SET_PERMISSIONS", []);
          removeToken();
          resolve();
        } else {
          logout()
            .then(() => {
              commit("SET_TOKEN", "");
              commit("SET_ROLES", []);
              commit("SET_PERMISSIONS", []);
              removeToken();
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        commit("SET_USERINFO", {});
        removeToken();
        resolve();
      });
    },
  },
};

export default user
